import { render, staticRenderFns } from "./ModifyWebHostingWebsiteAdminModal.vue?vue&type=template&id=025d07cc&scoped=true&"
import script from "./ModifyWebHostingWebsiteAdminModal.vue?vue&type=script&lang=js&"
export * from "./ModifyWebHostingWebsiteAdminModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025d07cc",
  null
  
)

export default component.exports